import { render, staticRenderFns } from "./EncyclopediaCategoryList.vue?vue&type=template&id=6657e9ad&scoped=true&"
import script from "./EncyclopediaCategoryList.vue?vue&type=script&lang=js&"
export * from "./EncyclopediaCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./EncyclopediaCategoryList.vue?vue&type=style&index=0&id=6657e9ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6657e9ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
